"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DatePicker_meta_1 = require("../DatePicker.meta");
var shared_1 = require("../../../../shared");
var rawCssPrefix = "\nbackground: #fff;\nborder: 1px solid rgba(0, 0, 0, 0.1);\nborder-radius: 4px;\nbox-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\nmargin-left: auto;\nmargin-top: 8px;\nmax-width: 310px;\nmin-width: 290px;\npadding: 16px 16px 20px;\nposition: relative;\ntransform: none;\nwidth: 100%;\nz-index: 600;\n\n@media (max-width: 35.9375em) {\n\tborder: 0;\n\tborder-radius: 0;\n\tborder-top-left-radius: 4px;\n\tborder-top-right-radius: 4px;\n\tbottom: 0;\n\tleft: 0;\n\tmargin: 0;\n\tmax-width: none;\n\tmin-height: 26em;\n\topacity: 0;\n\tpadding: 0 8% 20px;\n\tposition: absolute;\n\ttransform: translateZ(0) translateY(100%);\n\ttransition: transform 400ms ease, opacity 400ms ease, visibility 400ms ease;\n\tvisibility: hidden;\n\twill-change: transform, opacity, visibility;\n\n\t.is-active & {\n\t\topacity: 1;\n\t\ttransform: translateZ(0) translateY(0);\n\t\tvisibility: visible;\n\t}\n}\n";
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.categoryKey = DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY;
        _this.componentKey = DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY;
        return _this;
    }
    Dialog.prototype.render = function () {
        var _a = this.props, className = _a.className, innerRef = _a.innerRef, configuration = _a.configuration, props = __rest(_a, ["className", "innerRef", "configuration"]);
        return react_1.default.createElement("div", __assign({ className: className, ref: innerRef }, props));
    };
    return Dialog;
}(shared_1.ComponentBase));
exports.Dialog = Dialog;
exports.default = shared_1.InjectedStyledComponent(Dialog, DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY, DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY, ['dialogContent'], rawCssPrefix);
